import { config } from '../config'
import { SubTitle } from '../styles'

import { Heading } from '@ui/typography/Heading'

import { Wrapper, List, ListItem } from './styles'

const {
  solution: { features, text, title },
} = config

export function Solution() {
  return (
    <Wrapper>
      <Heading title={title} />
      <SubTitle>{text}</SubTitle>
      {features && (
        <List>
          {features.map(({ id, text }) => (
            <ListItem key={id}>{text}</ListItem>
          ))}
        </List>
      )}
    </Wrapper>
  )
}
